import { Slide } from 'components/UI/V2/Carousel/Slide';

const IMAGE_VIDEO = 'images/sliders/placeholder-video.png';

export const getAddonSlides = (description: string, onAdd?: () => void): Slide[] => [
    {
        id: 1,
        title: 'Name and price your Add-on.',
        description:
            '<p>Easily create add-on services by assigning a name and price.</p> <p>You can attach these add-ons to a primary service during the booking process or offer them as a standalone item during a quick checkout.</p>',
        image: 'images/sliders/addon/slider-addon-1.jpg',
        videoThumbnail: IMAGE_VIDEO,
        videoTitle: 'How to add an Add on service?',
        videoDuration: '0:31',
        videoUrl: 'https://www.loom.com/share/490b3c72a68a454aaa44b42cf1a5580d?t=0'
    },
    {
        id: 2,
        title: 'Some examples of Add-ons.',
        description: description,
        image: 'images/sliders/addon/slider-addon-2.jpg',
        primaryButton: {
            text: 'Add Add-on',
            color: '#EAB464',
            hoverColor: '#C18733',
            onClick: onAdd
        }
    }
];
